function capNumberAt(number, max) {
  return number > max ? (max + "+") : number;
}

export default capNumberAt;